import { Box, LoadingOverlay } from '@mantine/core';
import {
  PricingCard,
  PricingCardProps,
} from 'components/website/components/molecules/PricingCard/PricingCard';

export type ItemProps<T extends string> = {
  itemType: T;
  isLoading?: boolean;
} & PricingCardProps;

export const Item = <T extends string = string>({
  itemType,
  isLoading = false,
  ...props
}: ItemProps<T>) => {
  return (
    <Box pos="relative">
      <LoadingOverlay
        visible={isLoading}
        zIndex={100}
        overlayProps={{ blur: 2 }}
      />
      <PricingCard {...props} />
    </Box>
  );
};
